import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import clsx from 'clsx';
import { MoneyDisplay } from 'components';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ClassPassEdit } from './components';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const ClassPassInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.class_pass);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    setOpenEdit(true);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Class Pass Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Name</TableCell>
              <TableCell>{model.name_en}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Code</TableCell>
              <TableCell>{model.code}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>SKU</TableCell>
              <TableCell>{model.sku}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Price</TableCell>
              <TableCell><MoneyDisplay amount={model.price} currency={model.price_currency} /></TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Num of Passes</TableCell>
              <TableCell>{model.denominator}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Item Class</TableCell>
              <TableCell>{model.item_class?.label}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <ClassPassEdit onClose={handleEditClose} open={openEdit} />
    </Card>
  );
};

ClassPassInfo.propTypes = {
  className: PropTypes.string,
};

export default ClassPassInfo;
